import template from 'lodash-es/template';
import templateSettings from 'lodash-es/templateSettings';

// pathVariables - is object that contains key value pair that will replace :key name in path (as variable)
const insertPathVariables = (path, pathVariables) => {
  if (!pathVariables) {
    return path;
  }
  templateSettings.interpolate = /:([A-z]*)/g;
  // replacing the ':param' with param data
  return template(path)(pathVariables);
};

export { insertPathVariables };
